import React, {useEffect} from 'react';
import SwipeableViews from 'react-swipeable-views';
import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MoveButton from '../../../components/atoms/Button/MoveButton';
import BackButton from '../../../components/atoms/Button/BackButton';
import Form from '../../../components/organisms/Form';
import TabPanel from "../../../components/atoms/Panel/TabPanel";
import questionInfo from "../../../data/questionInfo";
import {inject, observer} from "mobx-react";
import {useHistory} from "react-router-dom";

const a11yProps = (index) => {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
};

const TestTemplate = inject("MainStore")(observer((props) => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const [value, setValue] = React.useState(0);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [value]);

    const handleChangeIndex = (index) => {
        setValue(index);

    };

    const validateNext = async () => {
        if (value === questionInfo.type.length - 1) {
            passToResult();
        } else {
            const result = await validationTab();

            if (result) {
                handleChangeIndex(value + 1);
            }
        }
    };

    const passToResult = async () => {
        const validFinal = await validationAll();

        if (validFinal) {
            if (window.fordate) {
                window.fordate.setMessage(JSON.stringify({
                    name: "master_banner",
                    link: "",
                    type: "end",
                }));
            }

            calculator();
        }
    };

    const prev = () => {
        handleChangeIndex(value - 1);
    };

    const mainPrev = () => {
        props.MainStore.setIsTest(false);
    };

    const calculator = () => {
        if (props.MainStore.resultSet.avoid >=  props.MainStore.resultSet.problem) {
            if (props.MainStore.resultSet.future >= 35 && props.MainStore.resultSet.conflict >= 35) {
                history.push("/result/4");
            } else if (props.MainStore.resultSet.future >= 35 && props.MainStore.resultSet.conflict < 35) {
                history.push("/result/5");
            } else if (props.MainStore.resultSet.future < 35 && props.MainStore.resultSet.conflict >= 35) {
                history.push("/result/6");
            } else if (props.MainStore.resultSet.future < 35 && props.MainStore.resultSet.conflict < 35) {
                history.push("/result/7");
            }
        } else {
            if (props.MainStore.resultSet.future >= 35 && props.MainStore.resultSet.conflict >= 35) {
                history.push("/result/0");
            } else if (props.MainStore.resultSet.future >= 35 && props.MainStore.resultSet.conflict < 35) {
                history.push("/result/1");
            } else if (props.MainStore.resultSet.future < 35 && props.MainStore.resultSet.conflict >= 35) {
                history.push("/result/2");
            } else if (props.MainStore.resultSet.future < 35 && props.MainStore.resultSet.conflict < 35) {
                history.push("/result/3");
            }
        }
    };

    const validationTab = () => {
        if (value === 0) {
            //조망
            for (let k = 0; k < props.MainStore.questionList[0].length; k++) {
                if (props.MainStore.questionList[0][k].value === undefined) {
                    alert("조망 항목을 모두 체크해주세요.");
                    handleChangeIndex(0);
                    return false;
                }
            }

            return true;
        } else if (value === 1) {
            //갈등
            for (let k = 0; k < props.MainStore.questionList[1].length; k++) {
                if (props.MainStore.questionList[1][k].value === undefined) {
                    alert("갈등 항목을 모두 체크해주세요.");
                    handleChangeIndex(1);
                    return false;
                }
            }

            return true;
        } else if (value === 2) {
            //애착 유형
            for (let k = 0; k < props.MainStore.questionList[2].length; k++) {
                if (props.MainStore.questionList[2][k].value === undefined) {
                    alert("불안/회피 항목을 모두 체크해주세요.");
                    handleChangeIndex(2);
                    return false;
                }
            }

            return true;
        }
    };

    const validationAll = () => {
        //조망
        for (let k = 0; k < props.MainStore.questionList[0].length; k++) {
            if (props.MainStore.questionList[0][k].value === undefined) {
                alert("조망 항목을 모두 체크해주세요.");
                handleChangeIndex(0);
                return false;
            }

            props.MainStore.resultSet.future += Number(props.MainStore.questionList[0][k].value);
        }

        //갈등
        for (let k = 0; k < props.MainStore.questionList[1].length; k++) {
            if (props.MainStore.questionList[1][k].value === undefined) {
                alert("갈등 항목을 모두 체크해주세요.");
                handleChangeIndex(1);
                return false;
            }

            props.MainStore.resultSet.conflict += Number(props.MainStore.questionList[1][k].value);
        }

        //불안회피
        for (let k = 0; k < props.MainStore.questionList[2].length; k++) {
            if (props.MainStore.questionList[2][k].value === undefined) {
                alert("불안/회피 항목을 모두 체크해주세요.");
                handleChangeIndex(2);
                return false;
            }

            if (props.MainStore.questionList[2][k].type === 0) {
                props.MainStore.resultSet.problem += Number(props.MainStore.questionList[2][k].value);
            } else {
                props.MainStore.resultSet.avoid += Number(props.MainStore.questionList[2][k].value);
            }
        }

        return true;
    };

    return (
        <div className={classes.root}>
            <CustomAppBar color="white" className={classes.head}>
                <CustomTabs
                    value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                >
                    {
                        questionInfo.type.map((data, index) => {
                            return (
                                <CustomTab key={index} label={data.name} {...a11yProps(data.index)} />
                            )
                        })
                    }
                </CustomTabs>
            </CustomAppBar>

            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
                className={classes.body}
                disabled={true}
            >
                {
                    questionInfo.type.map((data, index) => {
                        return (
                            <TabPanel key={index} value={value} index={data.index} dir={theme.direction}>
                                <Form list={props.MainStore.questionList[data.index]} changeHandler={props.MainStore.setQuestionValue} grade={questionInfo.grade}/>
                            </TabPanel>
                        )
                    })
                }
            </SwipeableViews>


            <BackButton className={classes.BackButton} width={true} transform={true} clickHandler={value == 0 ? mainPrev : prev}/>

            <MoveButton className={classes.MoveButton} width={true} transform={true} text={value !== questionInfo.type.length -1 ? "다음 페이지로" : "진단 결과 보기"} clickHandler={validateNext}/>
        </div>
    );
}));

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
    },
    head: {
        left:'50%',
        top:0,
        transform: 'translateX(-50%)',
        width:"100vw",
        '@media (min-width: 600px)': {
            width: "375px"
        },
    },
    body: {
        marginTop: '75px',
        boxSizing: 'border-box',
        paddingTop: '27px',
        paddingBottom: '70px',
    },
    guide: {
        position: 'fixed',
        display: 'flex',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        alignItems: 'center',
        padding: '0 10px',
        width: '100%',
        height:'30px',
        background: '#fff',
        zIndex:10,
        color: 'rgba(0,0,0,0.6)',
        fontWeight: '900',
        '@media (min-width: 600px)': {
            width: "375px"
        },
        '& p': {
            fontSize: '12px',
        },
    },

}));

const CustomAppBar = withStyles({
    root: {
        boxShadow: '0 0px 0px 0px rgba(0, 0, 0, 0)',
    },
})(AppBar);

const CustomTabs = withStyles({
    root: {
        height: '73px',
        borderBottom: '2px solid #b7b7b7',
        diesplay: 'flex',
        alignItems: 'center',
    },
    indicator: {
        display: 'none',
    },
})(Tabs);

const CustomTab = withStyles({
    textColorPrimary: {
        fontWeight: 'bold',
        paddingTop: '23px',
        '@media (min-width: 600px)': {
            minWidth: "0"
        },
        '&$selected': {
            color: '#3b3f42',
            fontWeight: '900',
        }
    },
    selected: {
        color: '#3b3f42',
    }
})(Tab);

export default TestTemplate;
